import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useToast } from "./use-toast";

import firestoreService from "../../services/firestoreService";

const useHazard = (projectId, hazardId) => {
  const [hazard, setHazard] = useState(() => {
    if (!projectId || !hazardId) {
      return {
        description: "",
        type: "",
        hazardSource: "",
        causes: [],
        consequences: [],
        riskCategory: [],
        mitigations: [],
        unmitigatedRisk: {
          probability: "",
          severity: "",
          rating: "",
        },
        sfairpStatement: "",
        retainedRisk: {
          probability: "",
          severity: "",
          rating: "",
        },
        residualRiskDescription: "",
        riskStatus: "Open",
        logs: [],
        systems: [],
        operatingModes: [],
        locations: [],
        projectLifecycles: [],
        disciplines: [],
        drawingPackages: [],
        users: [],
        meetings: [],
      };
    }
  });

  const { toast } = useToast();
  const navigate = useNavigate();

  const fetchHazard = useCallback(
    (projectId, hazardId) => {
      const unsubscribe = firestoreService.subscribeToItem(
        `projects/${projectId}/hazards`,
        hazardId,
        [],
        (hazard) => {
          if (!hazard) {
            console.error(
              "Hazard missing: Unable to retrieve specified hazard."
            );

            toast({
              variant: "destructive",
              title: "Hazard missing",
              description: "Unable to retrieve specified hazard.",
            });

            navigate(`projects/${projectId}/hazards`);
            return;
          }

          setHazard(hazard);
        }
      );

      return () => unsubscribe();
    },
    [navigate, toast]
  );

  useEffect(() => {
    if (projectId && hazardId) {
      fetchHazard(projectId, hazardId);
    }
  }, [fetchHazard, projectId, hazardId]);

  return { hazard, setHazard };
};

export default useHazard;
